import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  WelcomePackStatusHttpModel,
  WelcomePackStepEnum,
} from '../../http/welcome-pack/welcome-pack-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const WelcomePackActions = createActionGroup({
  source: 'Welcome Pack',
  events: {
    'Load Welcome Pack Status': emptyProps(),
    'Increment Welcome Pack Step': emptyProps(),
    'Decrement Welcome Pack Step': emptyProps(),
    'Close Welcome Pack': emptyProps(),
    'Finished Welcome Pack': emptyProps(),
    'Update Welcome Pack Step': props<{ step: WelcomePackStepEnum }>(),
  },
});

export const WelcomePackAPIActions = createActionGroup({
  source: 'Welcome Pack API',
  events: {
    'Loaded Welcome Pack Status Successfully': props<{
      welcomePackStatus: WelcomePackStatusHttpModel;
    }>(),
    'Loaded Welcome Pack Status Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
    'Updated Welcome Pack Status Successfully': props<{
      status: WelcomePackStatusHttpModel;
    }>(),
    'Updated Welcome Pack Status Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
